import React from "react";




import NavBarPage from "./NavBarPage";

const NavBarPlaceholder=(props)=>{


    

   return(
    <React.Fragment>
      <NavBarPage
       deployURL={props.deployURL}
       apiServer={props.apiServer} 
       apiServerHybrid={props.apiServerHybrid}

      />

      
    </React.Fragment>
  );

     

}


export default NavBarPlaceholder;